import React from "react";
import { Box, Skeleton } from "@mui/material";
import { navBarContainer, stackedBarsContainer } from "./UsageStyle";

export const NavbarSkeleton = () => {
  return (
    <Box sx={navBarContainer}>
      <Skeleton
        variant="rounded"
        width={"48%"}
        height={36}
        sx={{ bgcolor: "grey.800" }}
      />
      <Skeleton
        variant="rounded"
        width={"20%"}
        height={36}
        sx={{ bgcolor: "grey.800" }}
      />
    </Box>
  );
};

export const BarGraphSkeleton = () => {
  return (
    <Box sx={stackedBarsContainer}>
      <Skeleton variant="text" />
      <Skeleton
        variant="rounded"
        width={"98%"}
        height={300}
        sx={{ bgcolor: "grey.800" }}
      />
    </Box>
  );
};
